import React from "react";
export const Scrollable = ({ children, className, axis }) => {
    return (React.createElement("div", { className: `${className ?? ""} scrollable-${axis}` }, children));
};
